import { createFileRoute } from "@tanstack/react-router";

import Connect from "@/pages/connect";

export const Route = createFileRoute("/connect/")({
  component: ConnectPage,
  head: () => ({ meta: [{ title: "Connect" }] }),
});

function ConnectPage() {
  return <Connect />;
}
